export function openingsCountLabel(available: number | boolean): string {
  const count = Number(available);
  return count === 1 ? "1 opening" : `${count} openings`;
}
